import { createContext } from 'react';
import { CognitoUserAttribute } from '../../types';
import { useSSOConfigContext } from './SSOConfigContext';
import { useMembershipConfigContext } from './MembershipConfigContext';

export interface SiteConfigContextType {
  memberRequiredAttributes?: CognitoUserAttribute[];
  restrictedContentPrompt?: any | undefined;
}

export const siteConfigContext = createContext<
  SiteConfigContextType | undefined
>(undefined);

export const useSiteConfigContext = () => {
  const ssoConfig = useSSOConfigContext();
  const membershipConfig = useMembershipConfigContext();
  const context = ssoConfig || membershipConfig;

  if (!context) {
    return undefined;
  }
  return context;
};
